<template>
    <div>
        <h1 align="center">
            <strong><u>CREATOR POLICY </u></strong>
        </h1>
        <p align="center">
            <strong></strong>
        </p>
        <p>
            These <strong>Creator Terms and Conditions</strong> (hereinafter simply
            referred to as <strong>“Terms”</strong> or <strong>“Creator Terms”</strong>
            ) shall be applicable only to the Creators registered on TravelQuest.xyz
            and/or its related mobile application, namely,<strong>“TravelQuest”</strong> (hereinafter referred to as the<strong>“Website” </strong>or<strong> App”</strong> or<strong>“Site”</strong> or <strong>“Platform”</strong>), managed by<strong>TravelQuest</strong>, having its registered office in<strong>Sderot Tsahal 4, Lod, Israel </strong>(hereinafter referred to the<strong>“Company”</strong> or <strong>“TravelQuest”</strong> or    <strong>“Us”</strong> or <strong>“Our”</strong> or <strong>“We”</strong>).
            In these Terms, Creator shall be referred to as <strong>“Creator”</strong>
            or <strong>“You” </strong>or <strong>“Your”</strong>).
        </p>
        <p>
            In addition to these <strong>Creator Terms</strong>,<strong>Disclaimer</strong>, our <strong>Terms of Use</strong>,<strong>Privacy Policy</strong> statement and    <strong>Cookie Policy</strong>, shall also be applicable to you. In case,
            you are a user or customer, please refer to our    <strong>Terms of Use</strong> as applicable to users.
        </p>
        <ol start="1" type="1">
            <li>
                <strong>DEFINITIONS</strong>
            </li>
        </ol>
        <p>
            For the purposes of this Section, the following capitalised terms shall
            have the following meaning:
        </p>
        <ol start="1" type="1">
            <ol start="1" type="i">
                <li>
                    <strong>“Payment and Settlement Services”</strong>
                    shall mean remittance and settlement of any and all payments
                    collected by TravelQuest from the user or third party paying on
                    behalf of the user, for the tickets of the games or quests of the
                    Creator, to the designated bank accounts of the Creator or any
                    third party upon receipt of instructions from the Creator.
                </li>
                <li>
                    <strong>“Service”</strong>
                    shall mean the games or quests as made available by Creator to the
                    user/customer through the Platform.
                </li>
                <li>
                    <strong>“Creator”</strong>
                    shall have the meaning ascribed to it in the beginning of these
                    Terms. For the ease of reference, the terms ‘you’, ‘your’ under
                    this section have also been used to refer to the Creator.
                </li>
                <li>
                    <strong>“Standard Platform Services”</strong>
                    shall mean the use and access of the Platform by the Creator, which
                    includes but not limited to creation of games, and subsequent sale
                    of tickets by the Creator to the user, in accordance with these
                    Creator Terms. The Games are made up of various missions, which may
                    include activities such as submitting photos or videos, checking-in
                    at specific locations, or solving puzzles or riddles in order to
                    receive points. The games may be played with closed user groups
                    and/or the Internet community, more generally through the Website
                </li>
            </ol>
        </ol>
        <ol start="2" type="1">
            <li>
                <strong>ACCEPTANCE OF THESE TERMS</strong>
            </li>
        </ol>
        <p>
            By registering on our Website or App, or creating games, or selling
            tickets, or by clicking on a button or taking similar action to signify
            your affirmative acceptance of these Terms, you hereby represent that you
            have read, understood, and agreed to be bound by these Terms and any future
            updates and additions to these Terms, as published from time to time at the
            Website or App.
        </p>
        <p>
            <strong></strong>
        </p>
        <ol start="3" type="1">
            <li>
                <strong>ACCOUNT REGISTRATION AND VERIFICATION</strong>
            </li>
        </ol>
        <p>
            a) <strong>Account Registration: To register as a Creator with us</strong>
            <strong>
                , you are required to register and create an account with us.
            </strong>
            When setting up and maintaining your account, you must provide and continue
            to provide accurate and complete information about yourself.
            <a href="https://www.lawinsider.com/clause/account-password-and-security">
                As part
            </a>
            of the registration process, you will create a password and an account.
        </p>
        <p>
            b) <strong>Social Media Signup:</strong> You also have an option of signing
            up using social media accounts, such as Google and Facebook. In case, you
            chose to sign up using any of the social media account, you will be
            re-directed to the website of such social media account, and therefore, in
            addition to our policies, you will also be subject to the terms and privacy
            policy of such social media website.
        </p>
        <p>
            c) <strong>Security:</strong> You are responsible for maintaining the
            confidentiality of the password and account, and are fully responsible for
            all activities that occur under your account, including, without
            limitation, all actions by sub-users registered under your account. You
            agree to (a) immediately notify us of any unauthorized use of your password
            or account or any other breach of security, and (b) ensure that you exit
            from your account at the end of each session. We cannot and will not be
            liable for any loss, damage or other liability arising from your failure to
            comply with this Section or from any unauthorized access to or use of your
            account.
        </p>
        <p>
            d) <strong>Inaccurate Information:</strong> If we have reasonable grounds
            to suspect that any of the information submitted by you is untrue,
            inaccurate, outdated, or incomplete, we may terminate your account, freeze
            your funds, and refuse current or future use of any or all of the Services.
        </p>
        <ol start="4" type="1">
            <li>
                <strong>
                    SERVICE PROVIDER’S OBLIGATIONS, REPRESENTATIONS AND WARRANTIES
                </strong>
            </li>
            <ol start="1" type="i">
                <li>
                    You represent, warrant and agree that:
                </li>
                <ol start="1" type="a">
                    <li>
                        you are an individual or lawfully incorporated business entity
                        and are fully able and competent to understand and agree to the
                        Terms;
                    </li>
                    <li>
                        you have full power and authority to accept the Terms and to
                        perform your obligations hereunder;
                    </li>
                    <li>
                        you shall comply with all applicable laws while using and
                        accessing the Platform;
                    </li>
                    <li>
                        the game that you create on the Platform will comply with
                        applicable laws and you shall ensure that the users are not
                        exposed to harmful, violent, immoral, vulgar, unsafe,
                        unhygienic, dangerous, unsuitable content or environment by
                        playing your game or quest;
                    </li>
                    <li>
                        you shall be solely responsible for obtaining all necessary
                        third-party licenses and permissions (if any required)
                        regarding any activities that you engage the users in;
                    </li>
                    <li>
                        any service or content or description that Creator lists, does
                        not infringe or violate any of the copyright, patent,
                        trademark, trade name, trade secrets or any other personal or
                        proprietary rights of any third party (                <strong>“Third Party Rights”</strong>);
                    </li>
                    <li>
                        you agree not to cancel the game or quest after the users have
                        purchased the tickets;
                    </li>
                    <li>
                        all your games shall take place at the time, place and in the
                        manner as communicated to the users beforehand;
                    </li>
                    <li>
                        you will be polite and generous with the users or customers,
                        and will not abuse, harass, or be rude to the r users at any
                        point during your interaction with them;
                    </li>
                    <li>
                        all information provided by you or person acting on your behalf
                        relating to the games and services are complete and accurate;
                    </li>
                    <li>
                        the provision of services by you is in compliance with all
                        laws, regulations, and requirements as may be applicable.
                    </li>
                </ol>
                <li>
                    Creator will be required to provide information or material about
                    Creator’s services, entity, and its business as part of the
                    registration process on the Platform or your use of any Service or
                    the Creator account.            <em><u>Creator represents, warrants and agrees that</u></em>:
                </li>
                <ol start="1" type="a">
                    <li>
                        such information and material whether submitted during the
                        registration process or thereafter throughout the continuation
                        of the use of the Platform or Service is true, accurate,
                        current and complete; and
                    </li>
                    <li>
                        Creator will maintain and promptly amend all information and
                        material to keep it true, accurate, current and complete.
                    </li>
                </ol>
                <li>
                    Creator consents to the inclusion of the contact information about
                    Creator in TravelQuest’s database and usage of the same as per
                    Privacy Policy.
                </li>
                <li>
                    Creators are required to behave professionally with the users of
                    TravelQuest. Any misbehaviour, unprofessional conduct, verbal and
                    physical abuse is prohibited and will be considered as a violation
                    of these Terms.
                </li>
            </ol>
        </ol>
        <p>
            The failure of the Creator to comply with any of the above, or any other
            provision of these Terms can lead to necessary action taken by TravelQuest,
            including without limitation, suspension or removal of the account,
            freezing of funds and take other legal recourse, at the sole discretion of
            TravelQuest.
        </p>
        <ol start="5" type="1">
            <li>
                <strong>COMMISSION AND PAYMENT</strong>
            </li>
            <ol start="1" type="i">
                <li>
                    <strong>Cost of Ticket:</strong>
                    There are a couple of pays in which you may create a ticket:
                </li>
            </ol>
        </ol>
        <p>
            a) Creator may upload its quest to our TQ store and sell entry tickets to
            its quest using our payment process. We charge Creators a fee of 20% for
            each successful transaction.
        </p>
        <p>
            b) Creator can also create ticket and pay a fix price for each ticket each
            month. The price of self-created tickets is i) free for the first 10
            tickets, ii) US$3 for the next 40 tickets, iii) US$2 for the next 50
            tickets, and iv) US$1 for all tickets after that. To give an example,
            suppose a Creator creates 112 tickets in the last mouth. In such case, the
            Creator shall pay us 10x0 + 40x3$ + 50x2$ + 12x1$ = US$232.
        </p>
        <ol start="5" type="1">
            <ol start="2" type="i">
                <li>
                    <strong>Collection of Money</strong>
                    : All the money from the user for the services availed by them from
                    you, will be collected by TravelQuest.
                </li>
                <li>
                    <strong>Credit Card Information</strong>
                    : To create more than 10 (ten) self-created tickets, the Creator
                    needs to enter its credit card information.
                </li>
                <li>
                    <strong>Time of Payment</strong>
                    : On the 1st of each month, the Creator shall receive a summary of
                    the last mouth pertaining to all the tickets it has sold using TQ
                    payment process, and of all the tickets that it created by himself.
                    And on the 10<sup>th</sup> of such month, the Creator will be
                    charged and shall receive his payments            <em>(after we deduct our commission)</em>.
                    <strong>
                        We reserve the absolute right to modify and increase the
                        above-mentioned commission, at any time, at our sole discretion
                    </strong>
                    . When this will happen, we will send you an intimation through an
                    email or other communication, and the same shall be binding from
                    the date when we update the said commission percentage. Your
                    failure to read or receive such communication shall be no excuse in
                    the applicability of this on you.
                </li>
                <li>
                    <strong>Tax withholding</strong>
                    : In case any applicable law requires us to deduct taxes before
                    sending the payment to you, we will deduct such taxes, before
                    making the payment to you. You hereby consent us for the same.
                </li>
                <li>
                    <strong>User Complaint</strong>
                    : In case, the user has complained about the quality or any other
                    aspect of the service provided by you, we will look into such
                    complaint, provide you a reasonable opportunity of being heard, and
                    then take a decision on what action is to be taken against you. In
                    case, you are found to be violating any provision of these Terms,
                    we reserve the right to suspend or remove your account, freeze your
                    funds, and prohibit future use of our services to you, at our sole
                    discretion.<em> </em>
                    <u>
                        You hereby agree to fully co-operate with us on a timely basis
                        for the resolution of the complaints submitted by the users
                        against you or your services.
                    </u>
                </li>
            </ol>
        </ol>
        <ol start="6" type="1">
            <li>
                <strong>STANDARD PLATFORM SERVICES</strong>
            </li>
        </ol>
        <p>
            i. You are allowed to create games on the Platform subject to your
            compliance with these Creator Terms. These must be legal and not in
            contravention to any law for the time being in force.
        </p>
        <p>
            ii. You must ensure that your content or game does not infringe upon the
            intellectual property, trade secret or other proprietary rights or rights
            of publicity or privacy rights of third parties.
        </p>
        <p>
            iii. Your games must not expose the user or player to any sexual content,
            violence, harm, danger, nudity, vulgar, adult, unsafe, unhygienic, illegal,
            or restricted content or environment.
        </p>
        <ol start="7" type="1">
            <li>
                <strong>LIMITATION OF LIABILITY AND INDEMNITY</strong>
            </li>
            <ol start="1" type="i">
                <li>
                    We shall not have any liability whatsoever for any claims arising
                    from: (a) any of your acts or omissions; (b) compliance with the
                    instructions given by you or any person acting on your behalf; (c)
                    an act or order of any government authority; (d) any cause which we
                    could not avoid and the consequences whereof we could not prevent
                    by the exercise of reasonable diligence; (e) any loss, delay or
                    damage caused by user to you or your property; (f) any fraud or
                    cheating or mistreatment or abuse caused by the user to you; and/or
                    (g) any dispute or claims between the Creator and the user.
                </li>
                <li>
                    Creator agrees to indemnify TravelQuest, its users, its affiliates,
                    directors, employees, agents and representatives and to hold them
                    harmless, from any and all damages, losses, claims and liabilities
                    (including legal costs on a full indemnity basis) which may arise
                    from or in connection with: (i) your games; (ii) from your use of
                    the Platform or any of the Services; (iii) from your breach of the
                    Terms or breach of any applicable laws, including tax laws; (iv)
                    any liability or defect in the games offered through Platform; (v)
                    your negligence or wilful misconduct; (vi) any alleged or actual
                    patent, copyright, trade secret, trademark, trade name, or other
                    intellectual property right infringement or other claim, demand or
                    action resulting from the advertising, publishing, promotion, sale,
                    distribution or use of any of the Services; (vii) any alleged or
                    actual personal injury, death or property damage suffered by users
                    of TravelQuest arising from the games offered by Creator; and/or
                    (viii) any claim by a third Party or user made pursuant to, or
                    liability arising under any consumer protection laws, including any
                    non-conformity or defect in, or any recall of, any of games.
                </li>
            </ol>
        </ol>
        <p>
            11. <strong>DISCLAIMER</strong>
        </p>
        <p>
            a) We are a marketplace platform that connects Creators with the
            users/buyers. We shall not mediate or resolve any dispute or disagreement
            between you and buyers of your services.
        </p>
        <p>
            b) The site is provided on an “as-is” and “as available” basis, and
            TravelQuest (and our licensors and affiliates) expressly disclaim any and
            all warranties and conditions of any kind. We (and our licensors and
            affiliates) make no warranty that the Site or service will meet your
            requirements, will be available on an uninterrupted, timely, secure, or
            error-free basis, or will be accurate, reliable, free of viruses or other
            harmful code, complete, legal, or safe.
            <u>
                Additionally, we do not verify the background or genuineness of the
                users, and therefore we disclaim all warranties or guarantees in this
                respect whatsoever.
            </u>
        </p>
        <p>
            <strong>12. LIMITATION OF LIABILITY</strong>
        </p>
        <p>
            a) We will not be held responsible for any delay or failure to comply with
            our obligations under these conditions if the delay or failure arises from
            any cause which is beyond our reasonable control.
        </p>
        <p>
            b) To the maximum extent permitted by law, in no event shall TravelQuest
            (or our licensors or affiliates) be liable to you or any third party for
            any lost profits, lost data, or any indirect, consequential, exemplary,
            incidental, special or punitive damages arising from or relating to these
            terms or your use of, or inability to use or sell through, the site, even
            if TravelQuest has been advised of the possibility of such damages. Access
            to, and use of, the Site is at your own discretion and risk, and you will
            be solely responsible for any damage to your property, device or computer
            system, or loss of data resulting therefrom.
        </p>
        <p>
            c) To the maximum extent permitted by law, notwithstanding anything to the
            contrary contained herein, our liability to you for any damages arising
            from or related to these Terms (for any cause whatsoever and regardless of
            the form of the action), will at all times be limited to amount of tickets
            in question. The existence of more than one claim will not enlarge this
            limit.
        </p>
        <p>
            <strong> 13. INDEMNITY</strong>
        </p>
        <p>
            You acknowledge to defend, indemnify and hold TravelQuest, its buyers, its
            affiliates, subsidiaries, directors, officers, employees, agents, partners,
            and any other licensors (hereinafter referred to as    <strong> “Indemnified Party”</strong>) harmless from and against any claim,
            disputes, fine, liability, demand or expense, including reasonable
            attorneys’ fees, made by a third party, relating to, or arising from:    <strong></strong>
        </p>
        <p>
            a) Your violation of any third-party right, including without limitation to
            any right to privacy, publicity rights, defamation or intellectual property
            rights, including service that you list on the platform;
        </p>
        <p>
            b) Your wrongful or improper use of Platform;
        </p>
        <p>
            c) Your violation of any applicable laws, rules or regulations or any other
            applicable law through or related to the use of our Services;
        </p>
        <p>
            d) Your violation of these Terms or any other policy of TravelQuest as
            associated with our services;
        </p>
        <p>
            e) The indemnifications set forth above will survive the termination or
            expiration of these Terms and/or your use of our services.
        </p>
        <p>
            <strong> 14. TRANSACTION AND DISPUTES BETWEEN YOU AND USERS</strong>
        </p>
        <p>
            TravelQuest is merely a facilitator and is not and cannot be a party to or
            control in any manner any transactions of sale or purchase on the Platform.
            We shall not be liable to mediate or otherwise become party to any dispute
            between you and the buyer of your tickets on or off the platform.    <strong></strong>
        </p>
        <p>
            <strong>15. GOVERNING LAW AND DISPUTE RESOLUTION</strong>
        </p>
        <p>
            <strong> i. </strong>
            <strong>Governing Law: </strong>
            <a name="_Hlk69460853">
                The Terms and any dispute arising out of or relating to the same will
                be governed by applicable laws of the
            </a>
            <strong>State of Israel</strong>
            . <strong></strong>
        </p>
        <p>
            <strong> ii. </strong>
            <strong>Dispute Resolution:</strong>
        </p>
        <p>
            a) <strong>Amicable Resolution:</strong> If in case, any controversy,
            conflict or dispute of any nature arises between the Creator and
            TravelQuest, in connection with the provisions of these Terms, or our
            Privacy Policy, or out of or relating to or in connection with the use of
            our Website, the parties shall spend at least <strong>30 days</strong> to
            try and use all means to amicably resolve that dispute or conflict or
            controversy, with mutual discussions.
        </p>
        <p>
            b) <strong>Exclusive Jurisdiction: </strong>If however, the attempt to
            settle such a dispute amicably fail, then such controversy, conflict or
            dispute between the user and TravelQuest, shall be submitted to exclusive
            jurisdiction of the courts located within <strong>State of Israel.</strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong>16. NOTICES</strong>
        </p>
        <p>
            When you use the Website or App or send emails to TravelQuest, you are
            communicating with us electronically. You consent to receive electronically
            any communications related to your use of this Website or App.
            <em>
                <u>
                    TravelQuest will communicate with you by email, SMS, WhatsApp,
                    phone call or by posting notices on this Website or App
                </u>
            </em>
            . You agree that all agreements, notices, disclosures and other
            communications that are provided to you electronically satisfy any legal
            requirement that such communications be in writing. We may give notice by
            means of a general notice via electronic mail to your email address as
            available with us. If you want to give a notice to us, you can do so by
            dropping an electronic mail to <strong>dan@travelAndquest.com.</strong>
        </p>
        <p>
            <strong></strong>
        </p>
        <p>
            <strong> 17. MISCELLANEOUS</strong>
        </p>
        <p>
            i. <strong>Severability:</strong> If any provision of these Terms is held
            to be unenforceable or invalid, such provision will be changed and
            interpreted to accomplish the objectives of such provision to the greatest
            extent possible under applicable law and the remaining provisions of these
            Terms will continue in full force and effect.
        </p>
        <p>
            ii. <strong>Waiver:</strong> Our failure to insist on or enforce strict
            performance of these Terms of Use shall not be construed as a waiver by us
            of any provision or any right that we have to enforce these Terms and nor
            shall any course of conduct between TravelQuest and you or any other party
            be deemed to modify any provision of these Terms.
        </p>
        <p>
            iii. <strong>Survival: </strong>Notwithstanding any other provisions of
            these Creator Terms, or any general legal principles to the contrary, any
            provision of these Creator Terms that imposes or contemplates continuing
            obligations on either party shall survive the expiration or termination of
            these Terms of Use, for any reason whatsoever.
        </p>
        <p>
            iv. <strong>No Third-Party Beneficiaries: </strong>Except as otherwise
            expressly provided in these Creator Terms or Disclaimer or Terms of Use,
            there shall be no third-party beneficiaries.
        </p>
        <p>
            v. <strong>No Assignment: </strong>You may not assign these Creator Terms
            or Disclaimer or Terms of Use (or any rights, benefits or obligations
            hereunder) by operation of law or otherwise without the prior written
            consent of TravelQuest, which may be withheld at TravelQuest’s sole
            discretion. Any attempted assignment that does not comply with these
            Creator Terms or Disclaimer or Terms of Use shall be null and void.
        </p>
        <p>
            vi. <strong>Entire Agreement:</strong> The Creator Terms, Terms of Use,
            Privacy Policy, Cookie Policy, Disclaimer, together with any additional
            terms and conditions incorporated herein or referred to herein constitute
            the entire Agreement between TravelQuest and You, relating to the subject
            matter hereof, and supersedes any prior understanding or agreements
            (whether oral or written) regarding the subject matter, and may not be
            amended or modified except in writing or by making such amendments or
            modifications available on our Website or App.
        </p>
        <p>
            vii. <strong>Force Majeure:</strong> TravelQuest and its users will be
            excused from performance for any period during which, and to the extent
            that, such party is prevented from performing any obligation or service
            (such as processing or shipment or delivery of your order), in whole or in
            part, as a result of causes beyond its reasonable control, and without its
            fault or negligence, including without limitation, acts of God, strikes,
            lockouts, riots, acts of terrorism or war, epidemics, communication line
            failures, power failures and government-imposed lockdowns or similar
            restrictions.
        </p>
        <p>
            viii. <strong>Updates to these Terms: </strong>We may add to or change or
            update these Terms at any time, from time to time, entirely at our own
            discretion, with or without any prior written notice. You are responsible
            for checking these Terms periodically. Your use of the Site after any
            amendments to the Terms shall constitute your acceptance to such
            amendments.
        </p>
        <p>
            <strong> 18. CONTACT US</strong>
        </p>
        <p>
            <strong> </strong>
            If you have questions or need any clarification, please feel free to
            contact us at dan@travelAndquest.com
        </p>
        <p>
            Last Updated on 22.12.2021
        </p>
    </div>
</template>

<script>
export default {
    name: "v_Terms_CookiePolicy"
}
</script>

<style scoped>
p{
    margin: 16px;
}
</style>